// @flow strict
const PAGINATION = {
  PREV_PAGE: "← VOLTAR",
  NEXT_PAGE: "→ PROXIMA"
};

export default PAGINATION;
